var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 787,
    viewBox: "0 0 279 787",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M768.743 351.298C792.175 374.729 792.175 412.719 768.743 436.15L435.873 769.021C412.441 792.452 374.451 792.452 351.02 769.021L18.1493 436.15C-5.28214 412.719 -5.28214 374.729 18.1493 351.297L275.081 94.3661C277.033 92.4135 280.199 92.4135 282.152 94.3661L338.714 150.928C340.666 152.881 340.666 156.047 338.714 157.999L145.221 351.492C121.79 374.923 121.79 412.913 145.221 436.345L351.246 642.37C374.678 665.802 412.668 665.802 436.099 642.37L642.125 436.345C665.556 412.913 665.556 374.923 642.124 351.492L436.099 145.467C434.462 143.83 432.755 142.308 430.986 140.9L333.302 43.2158C331.349 41.2631 331.349 38.0973 333.302 36.1447L351.02 18.4269C374.451 -5.00456 412.441 -5.00456 435.873 18.4269L768.743 351.298Z",
    fill: "#F9F9FF",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/sidebar_bg.8350c5005bba1fd2208bb6cb5c7dfa0e.svg";
export { ForwardRef as ReactComponent };